import React from 'react';
import { View, Text, TextInput, StyleSheet } from 'react-native';
import { REDESIGN_TYPOGRAPHY, REDESIGN_SPACING } from '@/constants/residents/homeConstants';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import { GlassCard } from '@/components/shared/redesign';
import { MediaCarouselUpload, MediaUploadItem } from '@/components/common/residents/MediaCarouselUpload';
import { MAX_ATTACHMENTS } from '@/constants/residents';
import { useToast } from '@/contexts/admin/ToastContext';

interface StepDetailsRedesignProps {
  title: string;
  onTitleChange: (v: string) => void;
  description: string;
  onDescriptionChange: (v: string) => void;
  mediaItems: MediaUploadItem[];
  onMediaItemsChange: (items: MediaUploadItem[]) => void;
}

export const StepDetailsRedesign: React.FC<StepDetailsRedesignProps> = ({
  title,
  onTitleChange,
  description,
  onDescriptionChange,
  mediaItems,
  onMediaItemsChange,
}) => {
  const { colors } = useThemeColors();
  const { showError } = useToast();

  return (
    <View style={styles.container}>
      <Text style={[styles.heading, { color: colors.text.primary }]}>Tell us what happened</Text>

      <GlassCard padding={16} style={styles.field}>
        <Text style={[styles.label, { color: colors.text.muted }]}>Brief title</Text>
        <TextInput
          style={[styles.input, styles.titleInput, { color: colors.text.primary }]}
          value={title}
          onChangeText={onTitleChange}
          placeholder="A short summary"
          placeholderTextColor={colors.text.dimmer}
          maxLength={100}
        />
      </GlassCard>

      <GlassCard padding={16} style={styles.field}>
        <TextInput
          style={[styles.input, styles.textArea, { color: colors.text.primary }]}
          value={description}
          onChangeText={onDescriptionChange}
          placeholder="Describe the issue (optional)"
          placeholderTextColor={colors.text.dimmer}
          multiline
          numberOfLines={5}
          textAlignVertical="top"
          maxLength={1000}
        />
      </GlassCard>

      <MediaCarouselUpload
        files={mediaItems}
        onFilesChange={onMediaItemsChange}
        config={{ maxFiles: MAX_ATTACHMENTS, maxFileSizeMB: 2 }}
        onError={showError}
        variant="dark"
        showChevrons
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: { paddingHorizontal: REDESIGN_SPACING.horizontalPadding, gap: REDESIGN_SPACING.contentGap },
  heading: { ...REDESIGN_TYPOGRAPHY.heading1, marginBottom: 4 },
  field: { gap: 4 },
  label: { ...REDESIGN_TYPOGRAPHY.label },
  input: { ...REDESIGN_TYPOGRAPHY.body, lineHeight: 20 },
  titleInput: { height: 20, paddingVertical: 0 },
  textArea: { minHeight: 120 },
});

export default StepDetailsRedesign;
